
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 71 54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 2.5a2.5 2.5 0 015 0V54H0V2.5zM66 2.5a2.5 2.5 0 015 0V54h-5V2.5zM33 2.5a2.5 2.5 0 015 0V54h-5V2.5z","fill":"#CACACA"}})])
          )
        }
      }
    